import React from 'react'
import {useTestTag, ZapierTag} from 'Event/zapier'
import {ZAPIER} from 'organization/Event/Services/ServicesProvider'
import TestTagButton from 'organization/Event/Form/TestTagButton'

export default function TestZapierTagButton(props: {tag: ZapierTag | null}) {
  const addTag = useTestTag()

  return <TestTagButton tag={props.tag} integration={ZAPIER} addTag={addTag} />
}
